import React from "react";
import PropTypes from "prop-types";

const MultipleCustomColumn = ({
  customInputs,
  renderInput,
  layout = "vertical",
  naStates,
}) => {
  const containerStyle = {
    display: "flex",
    flexDirection: layout === "horizontal" ? "row" : "column",
    gap: "5px",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {customInputs.map((customInput, index) => {
        const isHidden =
          customInput.isNA &&
          customInput.isNA === true &&
          Object.keys(naStates).length > 0 &&
          Object.values(naStates)?.[0] === true
            ? true
            : customInput.isNA === false &&
              Object.keys(naStates).length > 0 &&
              Object.values(naStates)?.[0] === false
            ? true
            : false;
        return (
          !isHidden && (
            <div
              key={index}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <div
                style={{
                  minWidth: "fit-content",
                  flexShrink: 0,
                }}
              >
                {renderInput(customInput)}
              </div>
              {customInput.additionalText && (
                <span
                  className="multi-add-text "
                  style={{
                    whiteSpace: "wrap",
                    fontSize: "14px",
                    color: "white",
                    lineHeight: "1.2",
                    height: "33.2px",
                    padding: "2px",
                  }}
                >
                  {customInput.additionalText}
                </span>
              )}
            </div>
          )
        );
      })}
    </div>
  );
};

MultipleCustomColumn.propTypes = {
  customInputs: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      additionalText: PropTypes.string,
    })
  ).isRequired,
  renderInput: PropTypes.func.isRequired,
  layout: PropTypes.oneOf(["vertical", "horizontal"]),
};

export default MultipleCustomColumn;
